/* src/app/modules/employees/bajas/bajas-form.component.css */
.pic-hover,
.pdf-hover {
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  padding: 8px 16px;
  border: 2px dashed #ccc;
  border-radius: 8px;
  transition: all 0.3s ease;
  margin: 8px;
}
.pic-hover:hover,
.pdf-hover:hover {
  border-color: #007bff;
  background-color: #f8f9fa;
}
.icon {
  width: 20px;
  height: 20px;
  margin-right: 8px;
  fill: #666;
}
.black-text {
  color: #333;
  font-weight: 500;
}
.text-success {
  color: #28a745;
}
.text-center {
  text-align: center;
}
.mt-2 {
  margin-top: 0.5rem;
}
.mt-3 {
  margin-top: 1rem;
}
.mr-2 {
  margin-right: 0.5rem;
}
.mr-4 {
  margin-right: 1rem;
}
input[type=file] {
  display: none !important;
}
label[for=img-input],
label[for=pdf-input] {
  display: inline-block;
  width: 100%;
  text-align: center;
}
.upload-indicator {
  background-color: #f8f9fa;
  border: 1px solid #e9ecef;
  border-radius: 8px;
  padding: 20px;
  margin: 16px 0;
}
.upload-indicator .cf-dlg-loading {
  margin: 0 auto;
}
.upload-indicator p {
  margin: 8px 0 0 0;
  color: #495057;
}
.text-muted {
  color: #6c757d !important;
}
.small {
  font-size: 0.875rem;
}
.uploading input[type=file] {
  pointer-events: none;
  opacity: 0.6;
}
.uploading label {
  pointer-events: none;
  opacity: 0.6;
}
/*# sourceMappingURL=bajas-form.component.css.map */
